import { gsap } from 'gsap/all';
import { ScrollToPlugin } from 'gsap/all'


const WineClub = {
	init: function() {
		// console.log('WineClub specific code');
		gsap.registerPlugin(ScrollToPlugin);

		$('a').on('click', function(e){
			let target = $(this)
			if(target.attr('href') == '#join'){
				e.preventDefault();
				// let pos = $('#join').offset().top;

				let tl = gsap.timeline({duration: 0.8, ease: 'none', delay: 0})

				tl.to(window, {scrollTo: '#join'}, 0)
				console.log(tl);
			}
		})
	}
}

export default WineClub